import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  projectMediaPageToolsGrid: {
    display: "flex",
    alignItems: "center",
  },
  searchIconContainer: {
    borderRadius: "10px",
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "#252A38",
    minWidth: "350px",
  },

  addNewFolderButton: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    width: "auto",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "15px",
    color: theme.palette.text.secondary,
  },

  plusIcon: {
    width: "28px",
    height: "22px",
  },

  menuPop: {
    margin: "0px",
    backgroundColor: theme.palette.primary.main,
    border: `2px solid rgba(96, 100, 121, 1)`,
    borderRadius: "10px",
    padding: "4px",
  },
  menuPop2: {
    margin: "0px",
    backgroundColor: theme.palette.primary.main,
    border: `2px solid rgba(96, 100, 121, 1)`,
    borderRadius: "10px",
    padding: "4px",
    width: "350px",
    position: "absolute",
    marginTop: "10px",
    maxHeight: "365px",
    overflowY: "auto",
  },
  menuItems: {
    fontSize: "16px",
    borderRadius: "10px",
    backgroundColor: "transparent",
    fontFamily: "Poppins",
    gap: "12px",
  },
  menuItemCustom: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "5px",
  },

  menuName: {
    width: "170px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: theme.palette.text.tertiary,
    fontSize: "12px",
  },
  menuDate: {
    color: theme.palette.text.tertiary,
  },
  paperProp: {
    borderRadius: "20px",
  },

  //breadcrumbs
  separatorIcon: {
    color: theme.palette.text.primary,
  },
  breadCrumb: {
    color: theme.palette.text.tertiary,
    fontSize: "20px !important",
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.text.primary,
    },
    fontFamily: "poppins",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  endBreadCrumb: {
    color: theme.palette.text.primary,
    fontSize: "20px !important",
    fontFamily: "poppins",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  flexDiv: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    width: "100%",
    whiteSpace: "nowrap",
  },
  gap: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
  },
}));

export default useStyles;
